import { Notify } from '@flexisaf/flexibull2';
import { put, takeLatest } from 'redux-saga/effects';
import urls from 'utils/config';
import { SUCCESS, TOP_RIGHT } from 'utils/constants';
import { networkErrorHandler } from 'utils/errrorHandlers';
import request from 'utils/request';
import {
  fetchInterswitchConfig,
  fetchNabrollConfig,
  fetchPayproKanoConfig,
  fetchPaystackConfig,
  fetchPayUnimaidConfig,
  fetchRemitaConfig,
  importBankAccountsFailure,
  importBankAccountsSuccess,
} from '../actions';
import paymentConfigTypes from '../types';

const { API_BASE_URL } = urls || {};

function* importPaymentConfig({ payload: { id, cb } }) {
  const url = `${API_BASE_URL}/paylog-configurations`;
  const data = {
    configId: id,
  };
  const response = yield request({
    method: 'post',
    data,
    url,
  });
  if (response.success) {
    if (response.raw.paymentPlatform === 'REMITA') {
      yield put(fetchRemitaConfig(response.raw.id));
    } else if (response.raw.paymentPlatform === 'PAYSTACK') {
      yield put(fetchPaystackConfig(response.raw.id));
    } else if (response.raw.paymentPlatform === 'NABROLL') {
      yield put(fetchNabrollConfig(response.raw.id));
    } else if (response.raw.paymentPlatform === 'PAYPRO_KANO') {
      yield put(fetchPayproKanoConfig(response.raw.id));
    } else if (response.raw.paymentPlatform === 'PAYUNIMAID') {
      // TODO: this will be change to the paylog unimaid payment platform
      yield put(fetchPayUnimaidConfig(response.raw.id));
    } else {
      yield put(fetchInterswitchConfig(response.raw.id));
    }
    cb(response.raw.paymentPlatform);
    yield put(importBankAccountsSuccess());
    Notify(
      `${response.raw.paymentPlatform} bank accounts imported successfully`,
      {
        position: TOP_RIGHT,
        status: SUCCESS,
      }
    );
  } else {
    yield put(
      importBankAccountsFailure(
        'An error occured. Please reload the page to try again.'
      )
    );
    if (response.statusCode === 400) {
      networkErrorHandler(response?.statusCode, 'Invalid paylog ID');
    } else if (response.statusCode === 409) {
      networkErrorHandler(
        response?.statusCode,
        'Provided paylog id already exists'
      );
    } else {
      networkErrorHandler(
        response?.statusCode,
        'An error occured. Please reload the page to try again.'
      );
    }
  }
}

export function* onImportPaymentConfig() {
  yield takeLatest(
    paymentConfigTypes.IMPORT_PAYMENT_CONFIG_REQUEST,
    importPaymentConfig
  );
}
